export type PtSymbol = {
  /** Symbol without the maturity suffix, e.g. `PT-sUSDE`. */
  label: string
  /** Shorthand maturity, e.g. `29 May 25`. */
  maturityLabel: string
  /** Maturity at 00:00 UTC, for sorting. */
  maturity: Date
}

const PT_SYMBOL = /^(PT-.+)-(\d{1,2})([A-Z]{3})(\d{4})$/i
const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]
const MONTHS = MONTH_LABELS.map(month => month.toUpperCase())

/**
 * Splits a Pendle principal-token symbol (`PT-<underlying>-<DDMMMYYYY>`) into its
 * label and maturity. Returns `null` for anything that does not match that shape.
 */
export function parsePtSymbol(symbol: string): PtSymbol | null {
  const match = PT_SYMBOL.exec(symbol)
  if (!match) return null
  const [, label, day, monthAbbr, year] = match
  if (!label || !day || !monthAbbr || !year) return null

  const monthIndex = MONTHS.indexOf(monthAbbr.toUpperCase())
  if (monthIndex === -1) return null

  const maturity = new Date(Date.UTC(Number(year), monthIndex, Number(day)))
  if (maturity.getUTCDate() !== Number(day)) return null

  const monthLabel = MONTH_LABELS[monthIndex]
  return {
    label,
    maturityLabel: `${Number(day)} ${monthLabel} ${year.slice(2)}`,
    maturity
  }
}
